import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import { BrowserRouter } from "react-router-dom";

import "../excalidraw-app/sentry";

import ExcalidrawApp from "./App";
import { AuthProvider } from "./auth/AuthContext";

window.__EXCALIDRAW_SHA__ = import.meta.env.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW();
root.render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ExcalidrawApp />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
